module.exports = __webpack_public_path__ + "static/pfr-bar-a2bd18d3fc646a0c33895acdfbe4f056.jpg";